<template>
  <v-data-iterator
    :items="rates.data"
    :page.sync="page"
    :items-per-page.sync="size"
    :server-items-length="rates.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-rate-card v-for="(rate, index) in slot.items"
        :rate="rate"
        :key="index"
        @edit="$emit('edit', rate)"
      />
    </template>
  </v-data-iterator>
</template>


<script>

  export default {
    components: {
      'im-rate-card': () => import('@/components/Rate/RateCard')
    },

    props: {
      rates: Object
    },

    data: () => ({
      page: 1,
      size: 10,
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    watch: {
      page: {
        handler () {
          this.$emit('list', {
            size: this.size,
            page: this.page
          })
        },
        immediate: false,
        deep: true
      },
      size: {
        handler () {
          this.$emit('list', {
            size: this.size,
            page: this.page})
        },
        immediate: false,
        deep: true
      },
    },
  }

</script>